import { Icon, IconButton, Menu } from '@atom/mui';
import {
  ArrowDropDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './paginationControl.module.css';

const { MenuItem } = Menu;

const LIMIT_OPTIONS = [25, 50, 100];

const styles = {
  selectedMenuItemStyle: {
    color: colors.brand.blue,
  },
  iconStyle: {
    fill: colors.neutral.dim,
  },
};

interface Props {
  incrementPage: (value: number) => any;
  updateLimit: (value: string) => any;
  page: number;
  limit: number;
  total: number;
  limitOptions?: number[];
}

const PaginationControl = ({
  incrementPage,
  updateLimit,
  page = 1,
  limit = 25,
  total = 0,
  limitOptions = LIMIT_OPTIONS,
}: Props) => {
  const startRangeNumber = total === 0 ? 0 : (page - 1) * limit + 1;
  const limitTotal = page * limit;
  const totalLessThanLimit = total <= limitTotal;
  const endRangeNumber = totalLessThanLimit ? total : limitTotal;

  const handleUpdateLimit = value => {
    if (value !== limit) {
      updateLimit(value);
    }
  };

  return (
    <div className={classes.paginationContainer}>
      <div>Rows per page:</div>
      <div className={classes.paginationLimit}>{limit}</div>
      <Menu
        value={limit}
        icon={ArrowDropDownIcon}
        IconProps={{ color: colors.neutral.dim }}
        noMinWidth
      >
        {limitOptions.map((option, key) => (
          <MenuItem onClick={() => handleUpdateLimit(option)} key={key}>
            <span
              className={classes.limitOption}
              style={option === limit ? styles.selectedMenuItemStyle : {}}
            >
              {option}
            </span>
          </MenuItem>
        ))}
      </Menu>
      <div>{`${startRangeNumber}-${endRangeNumber} of ${total}`}</div>
      <div>
        <IconButton onClick={() => incrementPage(-1)} disabled={page === 1}>
          <Icon color={colors.neutral.dim} icon={ChevronLeftIcon} />
        </IconButton>
        <IconButton
          onClick={() => incrementPage(1)}
          disabled={totalLessThanLimit}
        >
          <Icon color={colors.neutral.dim} icon={ChevronRightIcon} />
        </IconButton>
      </div>
    </div>
  );
};

export default PaginationControl;
